export default "__VITE_ASSET__BZWIUU96__"